export default __webpack_public_path__ + "static/tecalis-share-2022-38d4936056c382900afb18c4bf36b116.png";